// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable */

body {
  background-color: #FFFFFF;
}

.ant-table-thead {
  font-size: var(--font-sm);
}

.ant-collapse-borderless > .ant-collapse-item {
  border: 0;
}

.loginscreen.middle-box {
  width: 100%;
}

.ant-tooltip-inner {
  max-width: 50rem;
}

.questionnaire-template-panel .ant-collapse-content-box {
  padding: 16px 16px 28px 16px;
}

.question-selected-panel .ant-collapse-content-box {
  padding: 16px 16px 28px 16px;
}

.ant-layout-sider-trigger {
  /*background: var(--blue-gradient);*/
  /*color: var(--white);*/
  border-right: 2px solid;
  /*border-right: 2px solid var(--typhoon);*/
}

.ant-menu-inline {
  border-right: none;
}

.ant-menu-inline .ant-menu-item:after {
  border-right: 4px solid;
  /*border-right: 4px solid var(--antd-blue);*/
}

.dropdown-filter .ant-dropdown-menu {
  max-height: 25rem;
  overflow: scroll;
}

.ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 25rem;
  overflow: scroll;
}

/*TODO: Should this be done differently? */
.device-survey-pane .ant-card-head {
  height: 55px;
}

.health-status-badge-lg > .ant-badge-status-dot {
  height: 12px;
  width: 12px;
}

.health-status-badge-sm > .ant-badge-status-dot {
  height: 8px;
  width: 8px;
}

.category-panel .ant-collapse-content-box {
  padding: 0;
}

.assigned-work-panel .ant-collapse-content-box {
  padding: 0;
}

.totem-table .ant-table-thead > tr > th {
  font-size: var(--font-md);
  /*color: var(--black0_8);*/
  /*background: var(--white);*/
  font-weight: 600;
}

.tooltip-table-header {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: center !important;
}

.totem-table .ant-table-tbody > tr > td {
  font-size: var(--font-md);
  /*color: var(--black0_8);*/
}

.totem-table .ant-table-tbody > tr .name-table-cell {
  /*color: var(--antd-blue);*/
  font-size: var(--font-md);
  cursor: pointer;
  font-weight: 600;
}

.totem-table .ant-table-tbody > tr .center-table-cell {
  font-size: var(--font-sm);
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.totem-table .ant-table-small > .ant-table-content > .ant-table-body {
  cursor: pointer;
  margin: 0;
}

.totem-table .totem-table-row-even {
  /*background: var(--white);*/
}

.totem-table .totem-table-row-odd {
  /*background: var(--fog);*/
}

.ant-table-row.disabled .ant-table-cell {
  /*color: var(--inactive);*/
}

.ant-table-row.disabled .ant-table-cell .ant-avatar {
  opacity: 50%;
}

.totem-table tr.ant-table-expanded-row {
  /*background: var(--white);*/
}

.totem-user-status-badge .ant-badge-status-dot {
  height: 8px;
  width: 8px;
}
`, "",{"version":3,"sources":["webpack://./client/styles/iconfont/styles.override.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAKtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ","sourcesContent":["/* stylelint-disable */\n\n@import '../fonts.css';\n@import '../colors.css';\n\nbody {\n  background-color: #FFFFFF;\n}\n\n.ant-table-thead {\n  font-size: var(--font-sm);\n}\n\n.ant-collapse-borderless > .ant-collapse-item {\n  border: 0;\n}\n\n.loginscreen.middle-box {\n  width: 100%;\n}\n\n.ant-tooltip-inner {\n  max-width: 50rem;\n}\n\n.questionnaire-template-panel .ant-collapse-content-box {\n  padding: 16px 16px 28px 16px;\n}\n\n.question-selected-panel .ant-collapse-content-box {\n  padding: 16px 16px 28px 16px;\n}\n\n.ant-layout-sider-trigger {\n  /*background: var(--blue-gradient);*/\n  /*color: var(--white);*/\n  border-right: 2px solid;\n  /*border-right: 2px solid var(--typhoon);*/\n}\n\n.ant-menu-inline {\n  border-right: none;\n}\n\n.ant-menu-inline .ant-menu-item:after {\n  border-right: 4px solid;\n  /*border-right: 4px solid var(--antd-blue);*/\n}\n\n.dropdown-filter .ant-dropdown-menu {\n  max-height: 25rem;\n  overflow: scroll;\n}\n\n.ant-table-filter-dropdown .ant-dropdown-menu {\n  max-height: 25rem;\n  overflow: scroll;\n}\n\n/*TODO: Should this be done differently? */\n.device-survey-pane .ant-card-head {\n  height: 55px;\n}\n\n.health-status-badge-lg > .ant-badge-status-dot {\n  height: 12px;\n  width: 12px;\n}\n\n.health-status-badge-sm > .ant-badge-status-dot {\n  height: 8px;\n  width: 8px;\n}\n\n.category-panel .ant-collapse-content-box {\n  padding: 0;\n}\n\n.assigned-work-panel .ant-collapse-content-box {\n  padding: 0;\n}\n\n.totem-table .ant-table-thead > tr > th {\n  font-size: var(--font-md);\n  /*color: var(--black0_8);*/\n  /*background: var(--white);*/\n  font-weight: 600;\n}\n\n.tooltip-table-header {\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: flex-start !important;\n  align-items: center !important;\n}\n\n.totem-table .ant-table-tbody > tr > td {\n  font-size: var(--font-md);\n  /*color: var(--black0_8);*/\n}\n\n.totem-table .ant-table-tbody > tr .name-table-cell {\n  /*color: var(--antd-blue);*/\n  font-size: var(--font-md);\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.totem-table .ant-table-tbody > tr .center-table-cell {\n  font-size: var(--font-sm);\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.totem-table .ant-table-small > .ant-table-content > .ant-table-body {\n  cursor: pointer;\n  margin: 0;\n}\n\n.totem-table .totem-table-row-even {\n  /*background: var(--white);*/\n}\n\n.totem-table .totem-table-row-odd {\n  /*background: var(--fog);*/\n}\n\n.ant-table-row.disabled .ant-table-cell {\n  /*color: var(--inactive);*/\n}\n\n.ant-table-row.disabled .ant-table-cell .ant-avatar {\n  opacity: 50%;\n}\n\n.totem-table tr.ant-table-expanded-row {\n  /*background: var(--white);*/\n}\n\n.totem-user-status-badge .ant-badge-status-dot {\n  height: 8px;\n  width: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
